import axiosInstance from '@libs/axiosInstance';

export const requestPasswordReset = async (email) => {
  try {
    const response = await axiosInstance.post('/account/request-reset-password/', { email });
    return response.data;
  } catch (error) {
    throw new Error('Failed to request password reset');
  }
};

export const resetPassword = async (userId, token, newPassword) => {
  try {
    const response = await axiosInstance.post(`/account/reset-password/${userId}/${token}/`, { password: newPassword });
    return response.data;
  } catch (error) {
    throw new Error('Failed to reset password');
  }
};
